<template>
	<form
		:class="[
			'styled-form',
			'styled-form--white-box',
			{'is-loading': isLoading}
		]"
		@submit.prevent="onSubmit"
	>

		<div v-if="isLoading" class="styled-form__overlay">
			<div class="preloader"></div>
		</div>

		<global-message v-if="errors.global" :value="errors.global"></global-message>

		<div class="styled-form__header">
			<h2 class="styled-form__title">Find your place and play football in 2023</h2>
		</div>

		<div class="o-grid o-grid--no-vgutter">

      <div class="o-grid__item o-1/1@tablet">
        <h2 class="common__heading bottom-gap-lg">Is this for you, your child or both?</h2>
        <span
            :class="['styled-form__error', {'is-visible': errors.identity}]"
            v-html="errors.identity">{{ errors.was_child_registered_with_a_club_in_2022 }}</span>
        <checkboxes-form-group
            v-model="data.identity"
            :checkboxes="identityCheckboxesGroup.checkboxes"
            :groupheading="identityCheckboxesGroup.heading"
            group-name="identityCheckboxesGroup"
            :clickHandler="identityClickHandler"
        ></checkboxes-form-group>
      </div>

			<div class="o-grid__item o-1/2@largeMobile top-gap-25">
				<form-input
					v-model="data.firstName"
					name="firstName"
					label="First Name *"
					:error="errors.firstName"
				></form-input>
			</div>

			<div class="o-grid__item o-1/2@largeMobile top-gap-25">
				<form-input
					v-model="data.lastName"
					name="lastName"
					label="Last Name *"
					:error="errors.lastName"
				></form-input>
			</div>

			<div class="o-grid__item o-1/3@largeMobile">
				<form-input
					v-model="data.email"
					name="email"
					label="Email *"
					:error="errors.email"
        ></form-input>
			</div>

      <div class="o-grid__item o-1/3@largeMobile">
        <select-input
            v-model="data.state"
            name="state"
            label="State *"
            :error="errors.state"
            :options="states"
        ></select-input>
      </div>

      <div class="o-grid__item o-1/3@largeMobile">
        <form-input
            v-model="data.postcode"
            name="postcode"
            label="Postcode *"
            :error="errors.postcode"
            class="to-lower-case"
        ></form-input>
      </div>

      <div class="o-grid__item o-1/1@tablet">
        <h2 class="common__heading bottom-gap-lg">Were you registered with a club in 2022? Yes/No</h2>
        <span
            :class="['styled-form__error', {'is-visible': errors.were_you_registered_with_a_club_in_2022}]"
            v-html="errors.were_you_registered_with_a_club_in_2022">{{ errors.were_you_registered_with_a_club_in_2022 }}</span>
        <checkboxes-form-group
            v-model="data.wereYouRegisteredWithAClubIn2022"
            :checkboxes="registrationCheckboxesGroup.checkboxes"
            :groupheading="registrationCheckboxesGroup.heading"
            group-name="registrationCheckboxesGroup"
            :clickHandler="registrationClickHandler"
            :error="errors.wereYouRegisteredWithAClubIn2022"
        ></checkboxes-form-group>
      </div>

      <div class="o-grid__item o-1/1@largeMobile top-gap-25" v-if="showChildClubNameField">
        <form-input
            v-model="data.clubName"
            :type="`textarea`"
            name="clubName"
            label="Club Name *"
            :error="errors.clubName"
            class="to-lower-case"
        ></form-input>
      </div>

      <div class="o-grid__item o-1/1@tablet" :class="{'top-gap-25': !data.wereYouRegisteredWithAClubIn2022}">
        <h2 class="common__heading bottom-gap-lg">Which football are you interested in?</h2>
        <span
            :class="['styled-form__error', {'is-visible': errors.footballType}]"
            v-html="errors.footballType">{{ errors.footballType }}</span>
        <checkboxes-form-group
            :checkboxes="footballTypeCheckboxesGroup.checkboxes"
            :groupheading="footballTypeCheckboxesGroup.heading"
            group-name="footballTypeCheckboxesGroup"
            :clickHandler="checkboxClickHandler"
        ></checkboxes-form-group>
      </div>

      <div class="o-grid__item o-1/1@largeMobile top-gap-25" v-if="showDisableOptions">
        <h2 class="common__heading bottom-gap-lg">Select disability options</h2>
        <span
            :class="['styled-form__error', {'is-visible': errors.footballType}]"
            v-html="errors.footballType">{{ errors.footballType }}</span>
        <checkboxes-form-group
            :checkboxes="disabilityCheckboxesGroup.checkboxes"
            :groupheading="disabilityCheckboxesGroup.heading"
            group-name="disabilityCheckboxesGroup"
            :clickHandler="disabilityCheckboxClickHandler"
        ></checkboxes-form-group>
      </div>

      <div class="o-grid__item o-1/1@largeMobile top-gap-25" v-if="isChildFootball">
        <select-input
            v-model="data.peopleCount"
            name="childCount"
            label="How many 18+ Family members? (1-5)*"
            :error="errors.peopleCount"
            :options="childCountArray"
        ></select-input>
      </div>

      <div class="o-grid__item o-1/1@largeMobile" v-if="isChildFootball">
        <select-input
            v-model="data.childCount"
            name="childCount"
            label="How many children? (1-5)*"
            :error="errors.childCount"
            :options="childCountArray"
        ></select-input>
      </div>

      <div class="o-grid__item o-1/1@tablet" v-if="isChildFootball">
        <h2 class="common__heading bottom-gap-lg">Was your child registered with a club in 2022? Yes/No</h2>
        <span
            :class="['styled-form__error', {'is-visible': errors.was_child_registered_with_a_club_in_2022}]"
            v-html="errors.was_child_registered_with_a_club_in_2022">{{ errors.was_child_registered_with_a_club_in_2022 }}</span>
        <checkboxes-form-group
            v-model="data.wasChildRegisteredWithAClubIn2022"
            :checkboxes="pastChildRegistrationCheckboxesGroup.checkboxes"
            :groupheading="pastChildRegistrationCheckboxesGroup.heading"
            group-name="pastChildRegistrationCheckboxesGroup"
            :clickHandler="pastChildRegistrationClickHandler"
        ></checkboxes-form-group>
      </div>

      <div class="o-grid__item o-1/1@largeMobile top-gap-25" v-if="showClubNameField">
        <form-input
            v-model="data.childClubName"
            :type="`textarea`"
            name="clubName"
            label="Club Name *"
            :error="errors.childClubName"
            class="to-lower-case"
        ></form-input>
      </div>

      <div class="o-grid__item o-1/1@largeMobile top-gap-25">
        <form-input
            v-model="data.comments"
            :type="`textarea`"
            name="comments"
            label="Comments"
            :error="errors.comments"
            class="to-lower-case"
        ></form-input>
      </div>

      <div class="o-grid__item o-1/1@largeMobile">
        <div class="o-grid--no-hgutter">
          <div class="o-grid--no-hgutter o-grid__item">
            <h1 class="common__heading m-auto">
              Collection Statement
            </h1>
          </div>
        </div>
      </div>

      <div class="o-grid__item o-1/1@largeMobile top-gap-15">
        <div class="o-grid--no-hgutter">
          <div class="o-grid__item">
            <div class="fanoffer-preferences-view__item m-auto">
              “We are pleased that you are interested in ‘Joining our Team’ to play football in 2023.
            </div>
          </div>
        </div>
      </div>

      <div class="o-grid__item o-1/1@largeMobile top-gap-15">
        <div class="o-grid--no-hgutter">
          <div class="o-grid__item">
            <div class="fanoffer-preferences-view__item m-auto">
              In completing this form, you are about to enter personal information into an online system maintained by Football Australia Limited (Football Australia).
            </div>
          </div>
        </div>
      </div>

      <div class="o-grid__item o-1/1@largeMobile top-gap-15">
        <div class="o-grid--no-hgutter">
          <div class="o-grid__item">
            <div class="fanoffer-preferences-view__item m-auto">
              Football Australia respects the privacy of individuals about whom we collect personal information. The personal information that Football Australia collects from you via the form is collected and used in accordance with relevant privacy laws for the purpose of processing your expression of interest to play football in 2023 and providing your with further information regarding your proposed registration.
            </div>
          </div>
        </div>
      </div>

      <div class="o-grid__item o-1/1@largeMobile top-gap-15">
        <div class="o-grid--no-hgutter">
          <div class="o-grid__item">
            <div class="fanoffer-preferences-view__item m-auto">
              Without the requested personal information, we cannot accept your expression of interest to play football and provide you with the related information. Football Australia’s <a href="https://www.footballaustralia.com.au/privacy">Privacy Policy</a> tells you more, including how to contact us to access and correct your details or make a complaint.
            </div>
          </div>
        </div>
      </div>

      <div class="o-grid__item o-1/1@largeMobile top-gap-15">
        <div class="o-grid--no-hgutter">
          <div class="o-grid__item">
            <div class="fanoffer-preferences-view__item m-auto">
              By submitting this form, you consent to the collection, use and disclosure of your personal information as described above.
            </div>
          </div>
        </div>
      </div>

      <div class="o-grid__item o-1/1@largeMobile top-gap-25">
        <checkbox-wrapped
            v-model="data.termsAndCondition"
            label="I have read the collection statement"
            :error="errors.termsAndCondition"
            :value="false"
        >
          <a href = "https://www.footballaustralia.com.au/sites/ffa/files/2021-12/21-1214%20-%20Create%20a%20Football%20Account%20Competition_Terms%20and%20Conditions_.pdf" target="new" class="styled-form__link"> CLICK HERE </a>
        </checkbox-wrapped>
      </div>

      <div class="recaptcha-container">
        <div class="recaptcha-wrapper"
             v-bind:class="{'recaptcha-wrapper-invalid' : (errors.recaptcha && errors.recaptcha.length)}">
          <vue-recaptcha
              ref="recaptcha"
              :size="data.reCaptchaSize"
              :loadRecaptchaScript="true"
              badge= 'inline'
              sitekey="6Lc4yaEgAAAAAGP_BEXyHbJYYwuC-t0d-hHfu3l_"
              @verify="onCaptchaVerified"
              @expired="onCaptchaExpired">
          </vue-recaptcha>
        </div>
        <label for="recaptcha" class="styled-form__error is-visible recaptcha-error"
               v-if="errors.recaptcha"
               :error="errors.recaptcha">Please verify you are not a robot.
        </label>
      </div>

      <div class="o-grid__item">
        <div class="text--center">
          <button class="btn btn-eoi-submit" :disabled="isLoading">Submit Your Interest</button>
        </div>
      </div>

		</div>
	</form>
</template>

<script>
	import FormInput from '../formFields/FormInput.vue';
	import GlobalMessage from '../messages/GlobalMessage.vue';
  import CheckboxWrapped from '../formFields/CheckboxWrapped.vue';
  import StyledDatePicker from '../formFields/StyledDatePicker.vue';
  import SelectInput from "../formFields/SelectInput";
  import isEmail from "../../helpers/isEmail";
  import isDisposableEmail from "../../helpers/isDisposableEmail";
  import moment from "moment/moment";
  import VueRecaptcha from 'vue-recaptcha';
  import States from "../../utils/australianStatesArray"
  import CheckboxesFormGroup from '../formGroups/CheckboxesFormGroup.vue';


  export default {
    components: {
      SelectInput,
      FormInput,
      GlobalMessage,
      CheckboxWrapped,
      StyledDatePicker,
      VueRecaptcha,
      CheckboxesFormGroup
    },
    props: {
      submit: {
        type: Function,
        required: true
      }
    },
    data() {
      return {
        isChanged: false,
        isLoading: false,
        states: States,
        childCountArray: [
          {
            id: "1",
            text: "1",
          },
          {
            id: "2",
            text: "2",
          },
          {
            id: "3",
            text: "3",
          },
          {
            id: "4",
            text: "4",
          },
          {
            id: "5",
            text: "5",
          }
        ],
        showClubNameField: false,
        showChildClubNameField: false,
        isChildFootball: false,
        showDisableOptions: false,
        data: {
          forChild: false,
          forYou: false,
          familyMember: false,
          youAndChild: false,
          firstName: '',
          lastName: '',
          email: '',
          peopleCount: '1',
          childCount: '1',
          clubName: '',
          childClubName: '',
          state: '',
          postcode: '',
          wasChildRegisteredWithAClubIn2022: '',
          wereYouRegisteredWithAClubIn2022: '',
          footballType: {},
          termsAndCondition: false,
          reCaptchaSize: '',
          recaptchaToken: ''
        },
        footballTypeCheckboxesGroup: {
          heading: {
            isDisabled: false
          },
          checkboxes: [{
            id: 'miniroos_kickoff',
            txt: 'MiniRoos Kick Off (4-9 years old)',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'miniroos_club_football',
            txt: 'MiniRoos (4-11 years old)',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'youth_football',
            txt: 'Youth Football (12-18 years old)',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'adult_football',
            txt: 'Adult Football (18-35 years old)',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'masters_football',
            txt: 'Masters Football (age 35+)',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'walking_football',
            txt: 'Walking Football',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'futsal',
            txt: 'Futsal',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'coaching',
            txt: 'Coaching',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'refereeing',
            txt: 'Refereeing',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'disability',
            txt: 'Disability',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }]
        },
        disabilityCheckboxesGroup: {
          heading: {
            isDisabled: false
          },
          checkboxes: [{
            id: 'special_olympics',
            txt: 'Special Olympics',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'para',
            txt: 'Para (CP)',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'deaf',
            txt: 'Deaf',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'blind',
            txt: 'Blind',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }]
        },
        pastChildRegistrationCheckboxesGroup: {
          heading: {
            isDisabled: false
          },
          checkboxes: [{
            id: 'yes',
            txt: 'yes',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'no',
            txt: 'no',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }]
        },
        registrationCheckboxesGroup: {
          heading: {
            isDisabled: false
          },
          checkboxes: [{
            id: 'yes',
            txt: 'yes',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'no',
            txt: 'no',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }]
        },
        identityCheckboxesGroup: {
          heading: {
            isDisabled: false
          },
          checkboxes: [{
            id: 'you',
            txt: 'You',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'child',
            txt: 'Your Child',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'family_member',
            txt: 'Family member 18+',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }, {
            id: 'you_and_child',
            txt: 'You and Child',
            isChecked: false,
            isDisabled: false,
            isShow: true
          }]
        },
        errors: {},
      }
    },
    methods: {
      checkboxClickHandler(groupName, checkboxIndex) {
        this.footballTypeCheckboxesGroup.checkboxes[checkboxIndex].isChecked = !this.footballTypeCheckboxesGroup.checkboxes[checkboxIndex].isChecked
        if (this.footballTypeCheckboxesGroup.checkboxes[checkboxIndex].isChecked) {
          this.data.footballType[this.footballTypeCheckboxesGroup.checkboxes[checkboxIndex].id] = this.footballTypeCheckboxesGroup.checkboxes[checkboxIndex].txt
        } else {
          delete this.data.footballType[this.footballTypeCheckboxesGroup.checkboxes[checkboxIndex].id]
        }

        this.isChildFootball = 'miniroos_kickoff' in this.data.footballType
            || 'miniroos_club_football' in this.data.footballType
            || 'youth_football' in this.data.footballType;

        this.showDisableOptions = 'disability' in this.data.footballType
      },
      disabilityCheckboxClickHandler(groupName, checkboxIndex) {
        this.disabilityCheckboxesGroup.checkboxes[checkboxIndex].isChecked = !this.disabilityCheckboxesGroup.checkboxes[checkboxIndex].isChecked
        if (this.disabilityCheckboxesGroup.checkboxes[checkboxIndex].isChecked) {
          if (typeof this.data.footballType.disability === 'string') {
            this.data.footballType.disability = {}
          }
          this.data.footballType.disability[this.disabilityCheckboxesGroup.checkboxes[checkboxIndex].id] = this.disabilityCheckboxesGroup.checkboxes[checkboxIndex].txt
        } else {
          delete this.data.footballType.disability[this.disabilityCheckboxesGroup.checkboxes[checkboxIndex].id]
        }
      },
      pastChildRegistrationClickHandler(groupName, checkboxIndex) {
        this.pastChildRegistrationCheckboxesGroup.checkboxes[+checkboxIndex].isChecked = !this.pastChildRegistrationCheckboxesGroup.checkboxes[checkboxIndex].isChecked
        this.pastChildRegistrationCheckboxesGroup.checkboxes[+!checkboxIndex].isChecked = !this.pastChildRegistrationCheckboxesGroup.checkboxes[checkboxIndex].isChecked

        this.data.wasChildRegisteredWithAClubIn2022 = checkboxIndex === 0
            ? this.pastChildRegistrationCheckboxesGroup.checkboxes[+checkboxIndex].isChecked
            : this.pastChildRegistrationCheckboxesGroup.checkboxes[+!checkboxIndex].isChecked

        this.showClubNameField = this.data.wasChildRegisteredWithAClubIn2022
      },
      registrationClickHandler(groupName, checkboxIndex) {
        this.registrationCheckboxesGroup.checkboxes[+checkboxIndex].isChecked = !this.registrationCheckboxesGroup.checkboxes[checkboxIndex].isChecked
        this.registrationCheckboxesGroup.checkboxes[+!checkboxIndex].isChecked = !this.registrationCheckboxesGroup.checkboxes[checkboxIndex].isChecked

        this.data.wereYouRegisteredWithAClubIn2022 = checkboxIndex === 0
            ? this.registrationCheckboxesGroup.checkboxes[+checkboxIndex].isChecked
            : this.registrationCheckboxesGroup.checkboxes[+!checkboxIndex].isChecked

        this.showChildClubNameField = this.data.wereYouRegisteredWithAClubIn2022
      },
      identityClickHandler(groupName, checkboxIndex) {
        const currentFlagValue = !this.identityCheckboxesGroup.checkboxes[checkboxIndex].isChecked

        this.data.forChild = false
        this.data.forYou = false
        this.data.familyMember = false
        this.data.youAndChild = false

        for (let i = 0; i < this.identityCheckboxesGroup.checkboxes.length; i++) {
          this.identityCheckboxesGroup.checkboxes[i].isChecked = false;

          if (checkboxIndex === 0) {
            this.data.forChild = this.identityCheckboxesGroup.checkboxes[checkboxIndex].isChecked = currentFlagValue;
          }

          if (checkboxIndex === 1) {
            this.data.forYou = this.identityCheckboxesGroup.checkboxes[checkboxIndex].isChecked = currentFlagValue;
          }

          if (checkboxIndex === 2) {
            this.data.familyMember = this.identityCheckboxesGroup.checkboxes[checkboxIndex].isChecked = currentFlagValue;
          }

          if (checkboxIndex === 3) {
            this.data.youAndChild = this.identityCheckboxesGroup.checkboxes[checkboxIndex].isChecked = currentFlagValue;
          }
        }

      },
      emailLowerCase() {
        if (this.data.email.length > 0) {
          this.data.email = this.data.email.toLowerCase();
        }

        if (this.data.confirmEmail.length > 0) {
          this.data.confirmEmail = this.data.confirmEmail.toLowerCase();
        }
      },
      clearEmailErrorMessage() {
        this.errors.confirmEmail = "";
        this.errors.email = "";
        delete this.errors.confirmEmail;
        delete this.errors.email;
      },
      onSubmit() {
        this.errors = this.validate(this.data);
        if (Object.keys(this.errors).length === 0) {
          this.isLoading = true;

          this.submit(this.data).catch(errors => {
            this.isLoading = false;
            // this.errors = errors;
            this.errors = {
              global: 'Something went wrong, please try again.'
            }
          });
        }
      },
      validate(data) {
        const errors = {};

        if (!data.firstName.length) errors.firstName = 'This field is required';
        if (new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?").test(data.firstName)) {
          errors.firstName = 'This field should not contain URL';
        }

        if (!data.lastName.length) errors.lastName = 'This field is required';
        if (new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?").test(data.lastName)) {
          errors.lastName = 'This field should not contain URL';
        }

        if (!data.email.length) {
          errors.email = 'This field is required';
        } else if (!isEmail(data.email) || isDisposableEmail(data.email)) {
          errors.email = 'Invalid email';
        }

        let postcodeErrors = this.validatePostcode(data.postcode);
        if (postcodeErrors.length) {
          errors.postcode = postcodeErrors;
        }

        let recaptchaError = this.validateRecaptcha(data.recaptchaToken);
        if (recaptchaError.length) {
          errors.recaptcha = recaptchaError;
        }

        if (data.wereYouRegisteredWithAClubIn2022 && !data.clubName) errors.wereYouRegisteredWithAClubIn2022 = 'This field is required';
        if (data.wasChildRegisteredWithAClubIn2022 && !data.childClubName) errors.wasChildRegisteredWithAClubIn2022 = 'This field is required';
        if (!data.state.length) errors.state = 'This field is required';
        if (!data.termsAndCondition) errors.termsAndCondition = 'You must agree to the terms and conditions!';
        if (Object.keys(data.footballType).length === 0) errors.footballType = 'Select at least one football type!';
        if (!/^[0-9]+$/.test(data.postcode)) {
          errors.postcode = 'Postcode should be numeric!';
        }

        return errors;
      },
      validatePostcode(postcode) {
        let errors = '';
        if (!this.data.checkIfUserIsOutsideOfAustralia) {
          const regex = new RegExp('^(?:(?:[2-8]\\d|9[0-7]|0?[28]|0?9(?=09))(?:\\d{2}))$');
          if (!postcode) {
            errors = 'This field is required';
          } else if (!regex.test(postcode)) {
            errors = 'Enter a valid postcode';
          }
        }
        return errors;
      },
      validateDateOfBirth(dateOfBirth) {
        let errors = '';

        let invalidYearsAgo = moment().subtract(115, 'years');
        if (!moment(dateOfBirth, 'YYYY-MM-DD').isValid()) {
          errors = 'This field is required';
        } else if (moment(dateOfBirth, 'YYYY-MM-DD').diff(moment(new Date())) > 0
            || moment(dateOfBirth, 'YYYY-MM-DD').diff(invalidYearsAgo, 'years') <= 0) {
          errors = 'Enter a valid date of birth';
        }
        return errors;
      },
      validateRecaptcha(token) {
        let recaptchaError = '';
        if (!token.length) {
          recaptchaError = "Please let us know that you are a human."
        }
        return recaptchaError;
      },
      onCaptchaVerified: function (recaptchaToken) {
        this.data.recaptchaToken = recaptchaToken;
        let recaptchaError = this.validateRecaptcha(recaptchaToken);
        if (recaptchaError.length) {
          this.errors.recaptcha = recaptchaError;
        } else {
          this.errors.recaptcha = '';
        }
      },
      onCaptchaExpired: function () {
        this.$refs.recaptcha.reset();
        this.data.recaptchaToken = "";
      }
    }
  };
</script>

<style lang="scss" scoped>

  .btn-eoi-submit {
    color: #00007d;
    border-radius: 30px;
    background-color: #6dfe6d !important;
  }

</style>
